import { useInterruptedJourneyRecovery } from './useInterruptedJourneyRecovery.js';

/** Tenant-scoped bootstrap for MS-REC-082 interrupted journey recovery. */
export function InterruptedJourneyRecoveryBootstrap(): null {
  useInterruptedJourneyRecovery();
  return null;
}
